import { TagType } from "@/api/enums";
import { ExpenseType } from "@/types";
import { IndexType } from "@/types/IndexType";

import { sprengConnectApi } from "../sprengConnectApi";
import { IndexChartDataResponse, PostGenerateIndexChartDataRequest } from "../types";
import { GetIndexDocumentParameters } from "../types/playgroundController/request/GetIndexLinkedDocumentParameters";

const indexApiPathSelector: { [key in IndexType]: (expenseType?: ExpenseType) => string } = {
  [IndexType.SIM]: () => "index/sim",
  [IndexType.SIPN]: () => "index/sipn",
  [IndexType.SIPI]: (expenseType?: ExpenseType) => `index/ipi${expenseType}`,
  [IndexType.SEPI]: () => "index/sepi",
  [IndexType.CRR3]: () => "index/crr3",
};

export const playgroundController = sprengConnectApi.injectEndpoints({
  endpoints: (builder) => ({
    playground_generateIndexChartData: builder.query<
      IndexChartDataResponse | undefined,
      PostGenerateIndexChartDataRequest
    >({
      query: (request) => {
        const { index, expenseType, ...rest } = request as { index: IndexType; expenseType?: ExpenseType };
        const url = indexApiPathSelector[index](expenseType);
        return {
          url: url,
          method: "post",
          body: rest,
        };
      },
      providesTags: () => [TagType.SprengConnectApi_IndexChartDataResponse],
    }),
    playground_getIndexDocument: builder.query<Uint8Array, GetIndexDocumentParameters>({
      query: ({ index, documentType }) => {
        return {
          url: `/index/${index}/document`,
          method: "GET",
          params: { documentType },
          responseHandler: (response): Promise<ArrayBuffer> => response.arrayBuffer(),
        };
      },
      transformResponse: (response: ArrayBuffer) => new Uint8Array(response),
    }),
  }),
});

export const {
  useLazyPlayground_generateIndexChartDataQuery,
  usePlayground_getIndexDocumentQuery,
  useLazyPlayground_getIndexDocumentQuery,
} = playgroundController;
